/**
 * схема для настроек таблицы срезов
 * @property {array} settingsItems - элементы настроек
 */
let schemeSettingsSlice = {
    columnSettings: {
        id: {
            type: 'text'
        },
        count: {
            type: 'text'
        },
        year: {
            type: 'text'
        },
        created_at: {
            type: 'text'
        }
    },
    labels: {
        id: 'ID среза',
        count: 'Кол-во конструкций',
        year: 'Год',
        created_at: 'Дата создания'
    }
}

export default schemeSettingsSlice;